<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <div class="input">
        <div class="text_info">
          <app-label [control]="bewilligungsjahrHaus" for="bewilligungsjahrHaus">Bewilligungsjahr des Hauses</app-label>
          <div class="info">
            <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get(isWohnung ? 'BEWILLIGUNGSJAHRWOHNUNGINFO' : 'BEWILLIGUNGSJAHRHAUSINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
          </div>
        </div>
        <mat-form-field>
          <input matInput id="bewilligungsjahrHaus" [maxlength]="4" formControlName="bewilligungsjahrHaus">
          <mat-error *ngIf="bewilligungsjahrHaus.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
          <mat-error *ngIf="bewilligungsjahrHaus.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          <mat-error *ngIf="!bewilligungsjahrHaus.hasError('pattern') && bewilligungsjahrHaus.hasError('min')">{{ 'MINVALUE' | translate:{'value': bewilligungsjahrHaus.errors.min.min} }}</mat-error>
          <mat-error *ngIf="!bewilligungsjahrHaus.hasError('pattern') && bewilligungsjahrHaus.hasError('max')">{{ 'MAXVALUE' | translate:{'value': bewilligungsjahrHaus.errors.max.max} }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
